// src/components/property-activities-cross-sell/property-activities-cross-sell.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
  var f,
    y,
    t,
    g,
    _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    };
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment PropertyActivitiesCrossSellActionFragment on PropertyActivitiesCrossSellLinkButton {\n    action {\n      actionType\n      activityId\n      analytics {\n        eventType\n        linkName\n        referrerId\n      }\n    }\n    button {\n      accessibility\n      iconPosition\n      text\n      icon {\n        id\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment PropertyActivitiesCrossSellDescriptionFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment PropertyActivitiesCrossSellHeadingFragment on LodgingHeader {\n    accessibilityLabel\n    icon {\n      id\n      token\n    }\n    text\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment PropertyActivitiesCrossSellPriceFragment on DisplayPrice {\n    price {\n      accessibilityLabel\n      formatted\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  query PropertyActivitiesCrossSellQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput!\n    $shoppingContext: ShoppingContextInput\n    $activityNaturalKey: ActivityNaturalKeyInput\n  ) {\n    propertyActivitiesCrossSell(\n      context: $context\n      propertyId: $propertyId\n      searchCriteria: $searchCriteria\n      shoppingContext: $shoppingContext\n      activityNaturalKey: $activityNaturalKey\n    ) {\n      actions {\n        ...PropertyActivitiesCrossSellActionFragment\n      }\n      activityId\n      description {\n        ...PropertyActivitiesCrossSellDescriptionFragment\n      }\n      heading {\n        ...PropertyActivitiesCrossSellHeadingFragment\n      }\n      liveAnnounceMessage\n      offerActivityDescription {\n        ...EGDSSpannableTextFragment\n      }\n      price {\n        ...PropertyActivitiesCrossSellPriceFragment\n      }\n      showTracking {\n        referrerId\n        linkName\n        eventType\n      }\n      sideSheet {\n        dismissButtonAccessibilityText\n        heading\n        subtitle\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
import React9 from "react";
import { gql as gql5, useQuery } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSSheet as EGDSSheet3, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { EGDSSpannableText } from "@shared-ui/lodging-fragments";
import { useRefContext, useVisibility, VisibilityEventType } from "@shared-ui/ref-context";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/property-activities-cross-sell/__private/__fragments/property-activities-cross-sell-action.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLink } from "@egds/react-core/link";
var __Fragment = gql(_templateObject());
var PropertyActivitiesCrossSellAction = function (param) {
  var data = param.data,
    onActionClick = param.onActionClick;
  var action = data.action,
    button = data.button;
  return /* @__PURE__ */React.createElement(React.Fragment, null, action.map(function (buttonAction, index) {
    var _button_icon;
    return /* @__PURE__ */React.createElement(EGDSLayoutGridItem, {
      key: "property-activities-cross-sell-action-".concat(index)
    }, /* @__PURE__ */React.createElement(EGDSLink, {
      onClick: function () {
        return onActionClick(buttonAction.actionType, buttonAction.analytics);
      }
    }, /* @__PURE__ */React.createElement("button", {
      type: "button",
      "aria-expanded": "false"
    }, button.text, (button === null || button === void 0 ? void 0 : button.icon) && /* @__PURE__ */React.createElement(EGDSIcon, {
      name: button === null || button === void 0 ? void 0 : (_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.id
    }))));
  }));
};
PropertyActivitiesCrossSellAction.displayName = "PropertyActivitiesCrossSellAction";
PropertyActivitiesCrossSellAction.fragment = __Fragment;
// src/components/property-activities-cross-sell/__private/__fragments/property-activities-cross-sell-description.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
var __Fragment2 = gql2(_templateObject1());
var PropertyActivitiesCrossSellDescription = function (param) {
  var data = param.data;
  var text = data.text;
  return /* @__PURE__ */React2.createElement(EGDSSpacing, {
    margin: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React2.createElement(EGDSText, null, text));
};
PropertyActivitiesCrossSellDescription.displayName = "PropertyActivitiesCrossSellDescription";
PropertyActivitiesCrossSellDescription.fragment = __Fragment2;
// src/components/property-activities-cross-sell/__private/__fragments/property-activities-cross-sell-heading.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading } from "@egds/react-core/text";
var __Fragment3 = gql3(_templateObject2());
var PropertyActivitiesCrossSellHeading = function (param) {
  var data = param.data;
  var icon = data.icon,
    text = data.text;
  return /* @__PURE__ */React3.createElement(EGDSLayoutFlex, null, icon && /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React3.createElement(EGDSSpacing2, {
    padding: {
      inlineend: "two"
    }
  }, /* @__PURE__ */React3.createElement(EGDSIcon2, {
    name: icon.id
  }))), /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React3.createElement(EGDSHeading, {
    size: 6
  }, text)));
};
PropertyActivitiesCrossSellHeading.displayName = "PropertyActivitiesCrossSellHeading";
PropertyActivitiesCrossSellHeading.fragment = __Fragment3;
// src/components/property-activities-cross-sell/__private/__fragments/property-activities-cross-sell-price.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var __Fragment4 = gql4(_templateObject3());
var PropertyActivitiesCrossSellPrice = function (param) {
  var data = param.data;
  var _data_price = data.price,
    accessibilityLabel = _data_price.accessibilityLabel,
    formatted = _data_price.formatted;
  return /* @__PURE__ */React4.createElement(EGDSText2, {
    weight: "bold",
    "aria-label": accessibilityLabel
  }, formatted);
};
PropertyActivitiesCrossSellPrice.displayName = "PropertyActivitiesCrossSellHeading";
PropertyActivitiesCrossSellPrice.fragment = __Fragment4;
// src/components/property-activities-cross-sell/property-activities-cross-sell-offer-dialog.tsx
import React6 from "react";
import { EGDSDialogContent } from "@egds/react-core/dialog";
import { EGDSSheet, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useDialog } from "@shared-ui/dialog-context";
import { useDialogId } from "@shared-ui/lodging-fragments";
import { CrossSellOffers, PackageType, ShoppingPathType } from "@shared-ui/retail-activities-cross-sell-offers";
// src/components/property-activities-cross-sell/__private/__fragments/property-activities-offers-sheet-header.tsx
import React5 from "react";
import { EGDSSpacing as EGDSSpacing3, EGDSSpacingHr } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText3 } from "@egds/react-core/text";
var PropertyActivitiesOfferSheetHeader = function (param) {
  var heading = param.heading,
    subHeading = param.subHeading;
  return /* @__PURE__ */React5.createElement(React5.Fragment, null, heading && /* @__PURE__ */React5.createElement(EGDSSpacing3, {
    margin: {
      blockstart: "four",
      inline: "three"
    }
  }, /* @__PURE__ */React5.createElement(EGDSHeading2, {
    tag: "h3"
  }, /* @__PURE__ */React5.createElement(React5.Fragment, null, heading))), subHeading && /* @__PURE__ */React5.createElement(EGDSSpacing3, {
    margin: {
      block: "one",
      inline: "three"
    }
  }, /* @__PURE__ */React5.createElement(EGDSText3, {
    whiteSpace: "pre-line"
  }, /* @__PURE__ */React5.createElement(React5.Fragment, null, subHeading))), (heading || subHeading) && /* @__PURE__ */React5.createElement(EGDSSpacingHr, null));
};
// src/components/property-activities-cross-sell/property-activities-cross-sell-offer-dialog.tsx
var PropertyActivitiesCrossSellOffersDialog = function (param) {
  var selectedOffers = param.selectedOffers,
    activityId = param.activityId,
    dateRange = param.dateRange,
    visible = param.visible,
    offerSheetHeading = param.offerSheetHeading,
    offerSheetSubHeading = param.offerSheetSubHeading,
    dismissButtonAccessibility = param.dismissButtonAccessibility,
    onTripClickHandler = param.onTripClickHandler,
    onDismiss = param.onDismiss;
  var _useDialog = _sliced_to_array(useDialog("activity-offer-dialog-".concat(useDialogId), "nestedOfferDialog"), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  React6.useEffect(function () {
    if (visible) {
      dialogActions.openDialog();
    }
  }, [visible]);
  if (!activityId) {
    return null;
  }
  var toolbarAction = function () {
    if (onDismiss) {
      dialogActions.closeDialog();
      onDismiss();
    }
  };
  return /* @__PURE__ */React6.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React6.createElement(DialogComponent, null, /* @__PURE__ */React6.createElement(EGDSSheet, {
    type: "full",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: null
  }, /* @__PURE__ */React6.createElement(EGDSToolbar, {
    navigationContent: {
      onClick: toolbarAction,
      navType: "close",
      navIconLabel: dismissButtonAccessibility
    }
  }), /* @__PURE__ */React6.createElement(EGDSDialogContent, null, /* @__PURE__ */React6.createElement(PropertyActivitiesOfferSheetHeader, {
    heading: offerSheetHeading,
    subHeading: offerSheetSubHeading
  }), /* @__PURE__ */React6.createElement(CrossSellOffers, {
    inputs: {
      selectedOffers: selectedOffers,
      activityId: activityId,
      dateRange: dateRange,
      shoppingPath: ShoppingPathType.PACKAGE,
      packageType: PackageType.HOTEL_ACTIVITY
    },
    onTripClickHandler: onTripClickHandler
  })))));
};
// src/components/property-activities-cross-sell/property-activities-cross-sell-offer-sheet.tsx
import React7 from "react";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent, EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { EGDSToolbar as EGDSToolbar2 } from "@egds/react-core/toolbar";
import { CrossSellOffers as CrossSellOffers2, PackageType as PackageType2, ShoppingPathType as ShoppingPathType2 } from "@shared-ui/retail-activities-cross-sell-offers";
var PropertyActivitiesCrossSellOffersSheet = function (param) {
  var visible = param.visible,
    selectedOffers = param.selectedOffers,
    activityId = param.activityId,
    dateRange = param.dateRange,
    offerSheetHeading = param.offerSheetHeading,
    offerSheetSubHeading = param.offerSheetSubHeading,
    dismissButtonAccessibility = param.dismissButtonAccessibility,
    onTripClickHandler = param.onTripClickHandler,
    onDismiss = param.onDismiss;
  if (!activityId) {
    return null;
  }
  var toolbarAction = function () {
    if (onDismiss) {
      onDismiss();
    }
  };
  return /* @__PURE__ */React7.createElement(EGDSSheetTransition2, {
    isVisible: visible
  }, /* @__PURE__ */React7.createElement(EGDSSheet2, {
    isVisible: visible,
    triggerRef: null,
    type: "side",
    sideSheetLayout: {
      position: "trailing",
      columns: 4
    }
  }, /* @__PURE__ */React7.createElement(EGDSToolbar2, {
    navigationContent: {
      onClick: toolbarAction,
      navIconLabel: dismissButtonAccessibility
    }
  }), /* @__PURE__ */React7.createElement(EGDSSheetContent, {
    padded: false
  }, /* @__PURE__ */React7.createElement(PropertyActivitiesOfferSheetHeader, {
    heading: offerSheetHeading,
    subHeading: offerSheetSubHeading
  }), /* @__PURE__ */React7.createElement(CrossSellOffers2, {
    inputs: {
      selectedOffers: selectedOffers,
      activityId: activityId,
      dateRange: dateRange,
      shoppingPath: ShoppingPathType2.PACKAGE,
      packageType: PackageType2.HOTEL_ACTIVITY
    },
    onTripClickHandler: onTripClickHandler
  }))));
};
// src/components/property-activities-cross-sell/property-activities-cross-sell-provider.tsx
import React8 from "react";
var defaultPropertyActivitiesCrossSellContext = {
  dateRange: "",
  setDateRange: function () {},
  triggerRefetch: false,
  setTriggerRefetch: function () {},
  activityNaturalKey: {
    offerToken: "",
    productToken: ""
  },
  setActivityNaturalKey: function () {},
  hasAvailableListings: false,
  setHasAvailableListings: function () {},
  propertyOffersMountRef: {
    current: false
  }
};
var PropertyActivitiesCrossSellContext = React8.createContext(defaultPropertyActivitiesCrossSellContext);
var PropertyActivitiesCrossSellContextProvider = function (param) {
  var children = param.children;
  var mountRef = React8.useRef(false);
  var propertyOffersMountRef = React8.useRef(false);
  var _React8_useState = _sliced_to_array(React8.useState(""), 2),
    dateRange = _React8_useState[0],
    setDateRange = _React8_useState[1];
  var _React8_useState1 = _sliced_to_array(React8.useState(false), 2),
    triggerRefetch = _React8_useState1[0],
    setTriggerRefetch = _React8_useState1[1];
  var _React8_useState2 = _sliced_to_array(React8.useState({
      offerToken: "",
      productToken: ""
    }), 2),
    activityNaturalKey = _React8_useState2[0],
    setActivityNaturalKey = _React8_useState2[1];
  var _React8_useState3 = _sliced_to_array(React8.useState(false), 2),
    hasAvailableListings = _React8_useState3[0],
    setHasAvailableListings = _React8_useState3[1];
  React8.useEffect(function () {
    if (mountRef.current) {
      setTriggerRefetch(true);
    }
  }, [activityNaturalKey.offerToken]);
  React8.useEffect(function () {
    mountRef.current = true;
  }, []);
  var providerValues = {
    dateRange: dateRange,
    setDateRange: setDateRange,
    triggerRefetch: triggerRefetch,
    setTriggerRefetch: setTriggerRefetch,
    activityNaturalKey: activityNaturalKey,
    setActivityNaturalKey: setActivityNaturalKey,
    hasAvailableListings: hasAvailableListings,
    setHasAvailableListings: setHasAvailableListings,
    propertyOffersMountRef: propertyOffersMountRef
  };
  var value = React8.useMemo(function () {
    return _object_spread({}, providerValues);
  }, [providerValues]);
  return /* @__PURE__ */React8.createElement(PropertyActivitiesCrossSellContext.Provider, {
    value: value
  }, children);
};
var usePropertyActivitiesCrossSellContext = function () {
  return React8.useContext(PropertyActivitiesCrossSellContext);
};
// src/components/property-activities-cross-sell/property-activities-cross-sell.tsx
var __Query = gql5(_templateObject4(), PropertyActivitiesCrossSellDescription.fragment, PropertyActivitiesCrossSellHeading.fragment, PropertyActivitiesCrossSellAction.fragment, PropertyActivitiesCrossSellPrice.fragment, EGDSSpannableText.fragment);
var HIDE_STICKY_TARGET_SECTION = "Offers";
var ViewportWrapper = function (param) {
  var wrapElement = param.wrapElement,
    children = param.children;
  if (wrapElement) {
    return /* @__PURE__ */React9.createElement(Viewport, null, /* @__PURE__ */React9.createElement(ViewLarge, null, children));
  }
  return children;
};
var PropertyActivitiesCrossSell = function (param) {
  var inputs = param.inputs,
    skipSsr = param.skipSsr,
    sectionRef = param.sectionRef;
  var searchCriteria = inputs.searchCriteria;
  var context = useBexApi().context;
  var getTargets = useRefContext().getTargets;
  var analyticsTracker = useClickTracker();
  var _React9_useState = _sliced_to_array(React9.useState(false), 2),
    isOffersOpen = _React9_useState[0],
    setOffersDialogOpen = _React9_useState[1];
  var _React9_useState1 = _sliced_to_array(React9.useState({}), 2),
    offersInput = _React9_useState1[0],
    setOffersInput = _React9_useState1[1];
  var _usePropertyActivitiesCrossSellContext = usePropertyActivitiesCrossSellContext(),
    hasAvailableListings = _usePropertyActivitiesCrossSellContext.hasAvailableListings,
    triggerRefetch = _usePropertyActivitiesCrossSellContext.triggerRefetch,
    setTriggerRefetch = _usePropertyActivitiesCrossSellContext.setTriggerRefetch,
    activityNaturalKey = _usePropertyActivitiesCrossSellContext.activityNaturalKey,
    setActivityNaturalKey = _usePropertyActivitiesCrossSellContext.setActivityNaturalKey;
  var _React9_useState2 = _sliced_to_array(React9.useState(false), 2),
    isStickyVisible = _React9_useState2[0],
    setIsStickyVisible = _React9_useState2[1];
  var dismissRef = React9.useRef(true);
  var isStickyVisibleRef = React9.useRef(true);
  var triggerBtn = React9.useRef(null);
  var targetSectionRef = sectionRef || HIDE_STICKY_TARGET_SECTION;
  var _getTargets = getTargets([targetSectionRef]),
    targetRef = _getTargets[targetSectionRef];
  var threshold = (targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) && typeof window !== "undefined" && targetRef.current.clientHeight > window.innerHeight ? window.innerHeight * 0.6 / targetRef.current.clientHeight : 0.3;
  var targetList = [{
    id: targetSectionRef,
    ref: targetRef || {
      current: null
    }
  }];
  var onTripClickHandler = React9.useCallback(function () {
    var _ref = _async_to_generator(function (action) {
      var _triggerBtn_current, offerNaturalKey, newOfferNaturalKey;
      return _ts_generator(this, function (_state) {
        switch (action.__typename) {
          case "ActivityAddOfferToTripAction":
            {
              offerNaturalKey = action.offerNaturalKey;
              setOffersDialogOpen(false);
              if (typeof setActivityNaturalKey === "function") {
                setActivityNaturalKey({
                  offerToken: offerNaturalKey.offerProductNaturalKey,
                  productToken: ""
                });
                analyticsTracker("HOT.HIS.HotelActivity.Sidesheet.AddToTrip", "AddToTrip");
              }
              break;
            }
          case "ActivityUpdateOfferInTripAction":
            {
              newOfferNaturalKey = action.newOfferNaturalKey;
              setOffersDialogOpen(false);
              if (typeof setActivityNaturalKey === "function") {
                setActivityNaturalKey({
                  offerToken: newOfferNaturalKey.offerProductNaturalKey,
                  productToken: ""
                });
                analyticsTracker("HOT.HIS.HotelActivity.Sidesheet.UpdateTrip", "UpdateTrip");
              }
              break;
            }
          case "ActivityRemoveOffersFromTripAction":
            {
              setOffersDialogOpen(false);
              if (typeof setActivityNaturalKey === "function") {
                setActivityNaturalKey({
                  offerToken: "",
                  productToken: ""
                });
                analyticsTracker("HOT.HIS.HotelActivity.Sidesheet.RemoveFromTrip", "RemoveFromTrip");
              }
              break;
            }
        }
        setIsStickyVisible(true);
        (_triggerBtn_current = triggerBtn.current) === null || _triggerBtn_current === void 0 ? void 0 : _triggerBtn_current.focus();
        return [2];
      });
    });
    return function (action) {
      return _ref.apply(this, arguments);
    };
  }(), [inputs, isOffersOpen]);
  var onVisibilityChange = React9.useCallback(function (visibilityEvents) {
    var targetVisible = false;
    Object.keys(visibilityEvents).forEach(function (sectionName) {
      targetVisible = sectionName === targetSectionRef && visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_TOP || visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_BOTTOM || visibilityEvents[sectionName] === VisibilityEventType.ENTER_COMPLETE;
    });
    if (dismissRef.current) {
      setIsStickyVisible(targetVisible);
    }
  }, [targetSectionRef]);
  useVisibility(targetList, onVisibilityChange, {
    thresholds: [threshold]
  });
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache"
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    refetch = _useQuery.refetch;
  React9.useEffect(function () {
    if (triggerRefetch && setTriggerRefetch) {
      refetch(_object_spread_props(_object_spread({}, variables), {
        activityNaturalKey: (activityNaturalKey === null || activityNaturalKey === void 0 ? void 0 : activityNaturalKey.offerToken) ? _object_spread({}, activityNaturalKey) : null
      })).then(function () {
        setTriggerRefetch(false);
      });
    }
  }, [triggerRefetch]);
  if (loading || error || !(data === null || data === void 0 ? void 0 : data.propertyActivitiesCrossSell) || !hasAvailableListings) {
    return null;
  }
  var _data_propertyActivitiesCrossSell = data.propertyActivitiesCrossSell,
    actions = _data_propertyActivitiesCrossSell.actions,
    description = _data_propertyActivitiesCrossSell.description,
    heading = _data_propertyActivitiesCrossSell.heading,
    liveAnnounceMessage = _data_propertyActivitiesCrossSell.liveAnnounceMessage,
    offerActivityDescription = _data_propertyActivitiesCrossSell.offerActivityDescription,
    price = _data_propertyActivitiesCrossSell.price,
    showTracking = _data_propertyActivitiesCrossSell.showTracking,
    sideSheet = _data_propertyActivitiesCrossSell.sideSheet,
    activityId = _data_propertyActivitiesCrossSell.activityId;
  if (isStickyVisible && isStickyVisibleRef.current && showTracking) {
    var referrerId = showTracking.referrerId,
      linkName = showTracking.linkName;
    isStickyVisibleRef.current = false;
    analyticsTracker("".concat(referrerId), "".concat(linkName));
  }
  var onDismissOffers = function () {
    var _triggerBtn_current;
    setOffersDialogOpen(false);
    setIsStickyVisible(true);
    (_triggerBtn_current = triggerBtn.current) === null || _triggerBtn_current === void 0 ? void 0 : _triggerBtn_current.focus();
  };
  var onActionClick = function (action, analytics) {
    var _searchCriteria_primary_dateRange, _searchCriteria_primary_dateRange1, _searchCriteria_primary_dateRange2, _searchCriteria_primary_dateRange3, _searchCriteria_primary_dateRange4, _searchCriteria_primary_dateRange5;
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      analyticsTracker("".concat(referrerId), "".concat(linkName));
    }
    var dateRange = {
      startDate: {
        day: (_searchCriteria_primary_dateRange = searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange === void 0 ? void 0 : _searchCriteria_primary_dateRange.checkInDate.day,
        month: (_searchCriteria_primary_dateRange1 = searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange1 === void 0 ? void 0 : _searchCriteria_primary_dateRange1.checkInDate.month,
        year: (_searchCriteria_primary_dateRange2 = searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange2 === void 0 ? void 0 : _searchCriteria_primary_dateRange2.checkInDate.year
      },
      endDate: {
        day: (_searchCriteria_primary_dateRange3 = searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange3 === void 0 ? void 0 : _searchCriteria_primary_dateRange3.checkOutDate.day,
        month: (_searchCriteria_primary_dateRange4 = searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange4 === void 0 ? void 0 : _searchCriteria_primary_dateRange4.checkOutDate.month,
        year: (_searchCriteria_primary_dateRange5 = searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange5 === void 0 ? void 0 : _searchCriteria_primary_dateRange5.checkOutDate.year
      }
    };
    switch (action) {
      case "OPEN" /* OPEN */:
      case "EDIT" /* EDIT */:
        setOffersInput({
          selectedOffers: (activityNaturalKey === null || activityNaturalKey === void 0 ? void 0 : activityNaturalKey.offerToken) ? [{
            offerProductNaturalKey: activityNaturalKey.offerToken
          }] : [],
          activityId: activityId,
          dateRange: dateRange,
          dismissButtonAccessibility: sideSheet === null || sideSheet === void 0 ? void 0 : sideSheet.dismissButtonAccessibilityText,
          offerSheetHeading: sideSheet === null || sideSheet === void 0 ? void 0 : sideSheet.heading,
          offerSheetSubHeading: sideSheet === null || sideSheet === void 0 ? void 0 : sideSheet.subtitle,
          onDismiss: onDismissOffers
        });
        triggerBtn.current = document.activeElement;
        if (!isOffersOpen) {
          setOffersDialogOpen(true);
          setIsStickyVisible(false);
        }
        break;
      case "DISMISS" /* DISMISS */:
        dismissRef.current = false;
        setIsStickyVisible(false);
        break;
      case "REMOVE" /* REMOVE */:
        if (typeof setActivityNaturalKey === "function") {
          setActivityNaturalKey({
            offerToken: "",
            productToken: ""
          });
        }
        break;
    }
  };
  return /* @__PURE__ */React9.createElement(React9.Fragment, null, /* @__PURE__ */React9.createElement(EGDSSheetTransition3, {
    isVisible: isStickyVisible && !isOffersOpen
  }, /* @__PURE__ */React9.createElement(EGDSSheet3, {
    isVisible: isStickyVisible && !isOffersOpen,
    type: "bottom",
    triggerRef: null,
    liveAnnounceString: liveAnnounceMessage
  }, /* @__PURE__ */React9.createElement(EGDSSheetContent2, null, /* @__PURE__ */React9.createElement(ViewportWrapper, {
    wrapElement: !!(activityNaturalKey === null || activityNaturalKey === void 0 ? void 0 : activityNaturalKey.offerToken)
  }, /* @__PURE__ */React9.createElement(React9.Fragment, null, /* @__PURE__ */React9.createElement(PropertyActivitiesCrossSellHeading, {
    data: heading
  }), /* @__PURE__ */React9.createElement(PropertyActivitiesCrossSellDescription, {
    data: description
  }))), offerActivityDescription && price && /* @__PURE__ */React9.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React9.createElement(EGDSLayoutGrid, {
    columns: ["auto", "max-content"]
  }, /* @__PURE__ */React9.createElement(EGDSSpacing4, {
    margin: {
      small: {
        inlineend: "three"
      },
      medium: {
        inlineend: "unset"
      }
    }
  }, /* @__PURE__ */React9.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    alignItems: "center"
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    alignItems: "center"
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React9.createElement(EGDSSpannableText, {
    data: offerActivityDescription
  }))))))), /* @__PURE__ */React9.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React9.createElement(PropertyActivitiesCrossSellPrice, {
    data: price
  })))), /* @__PURE__ */React9.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React9.createElement(EGDSLayoutGrid, {
    columns: ["max-content", "auto"],
    space: {
      column: "twelve"
    }
  }, actions.map(function (action, index) {
    return /* @__PURE__ */React9.createElement(EGDSLayoutGridItem2, {
      key: "property-activities-cross-sell-action-".concat(index)
    }, /* @__PURE__ */React9.createElement(PropertyActivitiesCrossSellAction, {
      data: action,
      onActionClick: onActionClick
    }));
  })))))), isOffersOpen && /* @__PURE__ */React9.createElement("div", {
    "data-stid": "activity-offer-side-sheet"
  }, /* @__PURE__ */React9.createElement(Viewport, null, /* @__PURE__ */React9.createElement(ViewSmall, null, /* @__PURE__ */React9.createElement(PropertyActivitiesCrossSellOffersDialog, _object_spread_props(_object_spread({}, offersInput), {
    visible: isOffersOpen,
    onTripClickHandler: onTripClickHandler
  }))), /* @__PURE__ */React9.createElement(ViewLarge, null, /* @__PURE__ */React9.createElement(PropertyActivitiesCrossSellOffersSheet, _object_spread_props(_object_spread({}, offersInput), {
    visible: isOffersOpen,
    onTripClickHandler: onTripClickHandler
  }))))));
};
PropertyActivitiesCrossSell.displayName = "sharedui-PropertyActivitiesCrossSell";
export { PropertyActivitiesCrossSell, PropertyActivitiesCrossSellContextProvider, usePropertyActivitiesCrossSellContext };